(function () {
  'use strict';

  var wrap = document.querySelector('[data-mz-search]');
  if (!wrap || !window.fetch) return;

  var site = wrap.getAttribute('data-site');
  var key = wrap.getAttribute('data-key');
  var bar = wrap.querySelector('#nn-popup-search');
  var input = wrap.querySelector('[data-mz-sp-input]');
  var panel = wrap.querySelector('[data-mz-sp]');
  if (!site || !key || !bar || !input || !panel) return;

  var termsWrap = panel.querySelector('[data-mz-sp-terms-wrap]');
  var termsList = panel.querySelector('[data-mz-sp-terms]');
  var prodsWrap = panel.querySelector('[data-mz-sp-prods-wrap]');
  var grid = panel.querySelector('[data-mz-sp-grid]');
  var title = panel.querySelector('[data-mz-sp-title]');
  var all = panel.querySelector('[data-mz-sp-all]');
  var empty = panel.querySelector('[data-mz-sp-empty]');
  var heartTpl = wrap.querySelector('[data-mz-sp-heart]');
  var heart = heartTpl ? heartTpl.innerHTML : '';

  var small = window.matchMedia('(max-width: 1023px)');
  var canHover = window.matchMedia('(hover: hover)');
  // same suggestion types and order as Unbxd's own panel
  var ORDER = ['PROMOTED_SUGGESTION', 'TOP_SEARCH_QUERIES', 'KEYWORD_SUGGESTION', 'IN_FIELD'];
  var cache = {};
  var typed = '';
  var req = 0;
  var open = false;
  var typeTimer = null;
  var hoverTimer = null;

  function count() { return small.matches ? 4 : 5; }

  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name.replace(/\./g, '\\.') + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }

  // the request Unbxd's panel makes, plus their visitor id for personalisation
  function ask(q) {
    var url = 'https://search.unbxd.io/' + key + '/' + site + '/autosuggest?q=' + encodeURIComponent(q || '*') +
      '&inFields.count=0&topQueries.count=0&keywordSuggestions.count=6&popularProducts.count=' + count() +
      '&promotedSuggestion.count=0&indent=off';
    if (!cache[url]) {
      var uid = cookie('unbxd.userId');
      cache[url] = fetch(url, uid ? { headers: { 'Unbxd-User-Id': uid } } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { return (d.response && d.response.products) || []; })
        .catch(function (e) { delete cache[url]; throw e; });
    }
    return cache[url];
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  }

  function mark(text, q) {
    var i = q ? text.toLowerCase().indexOf(q.toLowerCase()) : -1;
    if (i < 0) return esc(text);
    return esc(text.slice(0, i)) + '<strong>' + esc(text.slice(i, i + q.length)) + '</strong>' + esc(text.slice(i + q.length));
  }

  function money(n) {
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function tagged(p, tag) {
    return Array.isArray(p.tags) && p.tags.some(function (t) { return String(t).toLowerCase() === tag; });
  }

  function first(v) { return Array.isArray(v) ? v[0] : v; }

  function sized(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function terms(list) {
    var seen = {};
    return list.filter(function (p) {
      var v = (p.autosuggest || '').trim().toLowerCase();
      if (ORDER.indexOf(p.doctype) < 0 || !v || seen[v]) return false;
      seen[v] = true;
      return true;
    }).sort(function (a, b) { return ORDER.indexOf(a.doctype) - ORDER.indexOf(b.doctype); }).slice(0, 6);
  }

  function products(list) {
    return list.filter(function (p) { return /^POPULAR_PRODUCTS/.test(p.doctype) && p.productUrl; });
  }

  function card(p, i) {
    var price = parseFloat(first(p.price));
    var was = parseFloat(first(p.meta_compare_at_price));
    // slash pricing and sale styling follow the same tags as Unbxd's template
    var slash = tagged(p, 'show-slash-pricing') && was > price;
    var src = first(p.imageUrl);
    var url = esc(p.productUrl);
    var data = ' data-mz-sp-prod data-i="' + i + '" data-pid="' + esc(p.uniqueId) + '" data-q="' + esc(p.autosuggest || p.title) + '"';
    var img = src
      ? '<img src="' + esc(sized(src, 360)) + '" srcset="' + esc(sized(src, 240)) + ' 240w, ' + esc(sized(src, 360)) + ' 360w, ' + esc(sized(src, 480)) + ' 480w" sizes="(min-width: 1024px) 220px, 45vw" alt="" loading="lazy">'
      : '';
    return '<li class="mz-sp__card">' +
      '<div class="mz-sp__media"><a class="mz-sp__img" href="' + url + '" tabindex="-1" aria-hidden="true"' + data + '>' + img + '</a>' +
      (p.uniqueId ? '<button type="button" class="btn btn-add-to-wishlist p-0 btn-loader js-add-to-wishlist mz-sp__heart" data-id="' + esc(p.uniqueId) + '" aria-label="Add to wishlist" title="Add to wishlist">' + heart + '</button>' : '') +
      '</div>' +
      '<a class="mz-sp__name" href="' + url + '"' + data + '>' + esc(p.title || p.autosuggest) + '</a>' +
      (isNaN(price) ? '' : '<p class="mz-sp__price">' + (slash ? '<s>' + money(was) + '</s> ' : '') +
        '<span' + (slash || tagged(p, 'sale') ? ' class="is-sale"' : '') + '>' + money(price) + '</span></p>') +
      '</li>';
  }

  function fit() {
    if (panel.hidden) return;
    var room = window.innerHeight - panel.getBoundingClientRect().top;
    panel.style.setProperty('--mz-sp-room', Math.max(200, Math.floor(room)) + 'px');
  }

  function showProducts(list, q) {
    var prods = products(list);
    grid.innerHTML = prods.map(card).join('');
    prodsWrap.hidden = !prods.length;
    title.textContent = q ? 'Search results' : 'Best sellers';
    all.hidden = !q;
    if (q) all.href = '/search?search=' + encodeURIComponent(q);
    // lets the wishlist script fill in saved hearts
    if (window.jQuery) window.jQuery(document).trigger('nn_product_filter_done');
    return prods.length;
  }

  function render(list, q) {
    var t = terms(list);
    termsList.innerHTML = t.map(function (p, i) {
      var v = p.autosuggest.trim();
      return '<li><a href="/search?search=' + encodeURIComponent(v) + '" data-mz-sp-term data-i="' + i + '" data-type="' + esc(p.doctype) + '" data-q="' + esc(v) + '">' + mark(v, q) + '</a></li>';
    }).join('');
    termsWrap.hidden = !t.length;
    var found = showProducts(list, q) + t.length;
    empty.hidden = !!found || !q;
    empty.textContent = found ? '' : 'No results found for "' + q + '".';
    panel.hidden = !found && !q;
    fit();
  }

  function load(q) {
    typed = q;
    var id = ++req;
    ask(q).then(function (list) {
      if (id === req && open) render(list, q);
    }).catch(function () {
      if (id === req) panel.hidden = true;
    });
  }

  // pointing at a suggestion previews its products, like Unbxd's panel
  function preview(link) {
    clearTimeout(hoverTimer);
    var q = link.getAttribute('data-q');
    var id = req;
    hoverTimer = setTimeout(function () {
      ask(q).then(function (list) {
        if (id === req && products(list).length) showProducts(list, q);
      }).catch(function () {});
    }, 150);
  }

  function track(type, data) {
    try { if (window.Unbxd && typeof window.Unbxd.track === 'function') window.Unbxd.track(type, data); } catch (e) {}
  }

  bar.addEventListener('show.bs.collapse', function () { open = true; load(input.value.trim()); });
  bar.addEventListener('shown.bs.collapse', fit);
  bar.addEventListener('hide.bs.collapse', function () {
    open = false;
    req++;
    clearTimeout(typeTimer);
    clearTimeout(hoverTimer);
    panel.hidden = true;
  });

  input.addEventListener('input', function () {
    clearTimeout(typeTimer);
    typeTimer = setTimeout(function () { load(input.value.trim()); }, 150);
  });

  input.form.addEventListener('submit', function (e) {
    if (!input.value.trim()) e.preventDefault();
  });

  termsList.addEventListener('mouseover', function (e) {
    var link = e.target.closest('[data-mz-sp-term]');
    if (link && canHover.matches) preview(link);
  });
  termsList.addEventListener('focusin', function (e) {
    var link = e.target.closest('[data-mz-sp-term]');
    if (link) preview(link);
  });

  // same events Unbxd's panel sends, so its ranking keeps learning
  panel.addEventListener('click', function (e) {
    var term = e.target.closest('[data-mz-sp-term]');
    var prod = e.target.closest('[data-mz-sp-prod]');
    var hit = term || prod;
    if (!hit) return;
    var params = {
      unbxdprank: parseInt(hit.getAttribute('data-i'), 10) + 1,
      internal_query: typed || '*',
      autosuggest_type: term ? hit.getAttribute('data-type') : 'POPULAR_PRODUCTS'
    };
    if (term) params.autosuggest_suggestion = hit.getAttribute('data-q');
    else params.pid = hit.getAttribute('data-pid');
    track('search', { query: hit.getAttribute('data-q'), autosuggestParams: params });
    if (prod) track('click', { pid: params.pid });
  });

  // arrow keys walk from the box through suggestions and products
  wrap.addEventListener('keydown', function (e) {
    if ((e.key !== 'ArrowDown' && e.key !== 'ArrowUp') || panel.hidden) return;
    var list = Array.prototype.slice.call(panel.querySelectorAll('[data-mz-sp-term], .mz-sp__name'));
    var at = list.indexOf(document.activeElement);
    if (at < 0 && document.activeElement !== input) return;
    if (!list.length) return;
    e.preventDefault();
    var next = at + (e.key === 'ArrowDown' ? 1 : -1);
    if (next < 0) input.focus();
    else list[Math.min(next, list.length - 1)].focus();
  });

  window.addEventListener('resize', fit);
  small.addEventListener('change', function () {
    if (open) load(input.value.trim());
  });
})();
